import { Control, FieldValues, Path } from 'react-hook-form';
import { AutocompleteControl } from '../form/AutoCompleteControl';

const TITLE_OPTIONS = ['Dr.', 'Prof.', 'Prof. Dr.', 'Dipl. -Ing.'];
// Require at least one unicode letter
const PATTERN = /\p{L}+/u;

type TitleAutocompleteProps<T extends FieldValues> = {
  name: Path<T>;
  id?: string;
  control: Control<T>;
};

export function TitleAutocompleteControl<T extends FieldValues>(props: TitleAutocompleteProps<T>) {
  const { control, name, id } = props;

  return <AutocompleteControl name={name} control={control} options={TITLE_OPTIONS} id={id} rules={{ pattern: PATTERN }} freeSolo />;
}
